__turbopack_context__.v({
  "wrapper": "ethical-code-module-scss-module__8s1jwq__wrapper",
  "wrapper__label": "ethical-code-module-scss-module__8s1jwq__wrapper__label",
});
